import React, { useCallback,useRef, useState } from "react";

import styles from "./FileUploadZone.module.css";

export const FileUploadZone = ({
  onFileSelect,
  selectedFile,
  hasError = false,
  accept = "image/*,.pdf,.doc,.docx",
  hint = "Maximum size: 50MB",
}) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onFileSelect(file);
    }
  };

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);

      const file = e.dataTransfer.files?.[0];
      if (file) {
        onFileSelect(file);
      }
    },
    [onFileSelect]
  );

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  return (
    <div
      className={`${styles.uploadZone} ${isDragging ? styles.dragging : ""} ${
        selectedFile ? styles.hasFile : ""
      } ${hasError ? styles.error : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleFileChange}
        className={styles.fileInput}
        accept={accept}
      />

      {selectedFile ? (
        <div className={styles.fileInfo}>
          <div className={styles.fileIcon}>📄</div>
          <div className={styles.fileDetails}>
            <p className={styles.fileName}>{selectedFile.name}</p>
            <p className={styles.fileSize}>
              {formatFileSize(selectedFile.size)}
            </p>
          </div>
          <button
            type="button"
            className={styles.removeButton}
            onClick={(e) => {
              e.stopPropagation();
              onFileSelect(null);
              if (fileInputRef.current) {
                fileInputRef.current.value = "";
              }
            }}
          >
            ×
          </button>
        </div>
      ) : (
        <div className={styles.uploadContent}>
          <p className={styles.uploadText}>
            Drop your files here or{" "}
            <span className={styles.uploadLink}>Browse</span>
          </p>
          {hint && <p className={styles.uploadHint}>{hint}</p>}
        </div>
      )}
    </div>
  );
};
